import packageInfo from '../../package.json'

// 以 Model 為單位共用，供各 Agree 的獨立 load / submit hooks 使用。
// 不保存答案、文字、ac 或 tk；重新載入頁面後，以實際 LoadAnswers 結果重新判定。
const sessions = new WeakMap()

function sessionFor(survey) {
  if (!survey) return null
  if (!sessions.has(survey)) {
    sessions.set(survey, { resumed: false, load: 'not_attempted', events: [] })
  }
  return sessions.get(survey)
}

// detail 只放題名、原因這類短代碼（如 { q: 'q1', reason: 'option_gone' }），
// 不放答案文字。
export function recordProgressEvent(survey, event, count, detail) {
  const session = sessionFor(survey)
  if (!session) return
  if (event === 'load_started') session.load = 'loading'
  if (event === 'load_empty') session.load = 'empty'
  if (event === 'load_received') {
    session.resumed = true
    session.load = 'received'
  }
  if (event === 'load_applied') session.load = 'applied'
  if (event === 'load_failed') session.load = 'failed'
  session.events.push({
    event,
    at: new Date().toISOString(),
    ...(Number.isInteger(count) ? { count } : {}),
    ...(detail && typeof detail === 'object'
      ? {
          detail: Object.entries(detail)
            .map(([k, v]) => `${k}=${String(v).slice(0, 60)}`)
            .join(' '),
        }
      : {}),
  })
  session.events = session.events.slice(-6)
}

export function getProgressDiagnostics(survey) {
  const session = sessionFor(survey)
  const asset =
    typeof document !== 'undefined'
      ? Array.from(document.scripts)
          .map(
            (script) => script.src.match(/\/(main\.[\w.-]+\.js)(?:\?|$)/)?.[1]
          )
          .find(Boolean)
      : undefined
  return {
    version: packageInfo.version,
    build: process.env.REACT_APP_BUILD_SHA || asset || 'unknown',
    resumed: session?.resumed ?? false,
    load: session?.load || 'not_attempted',
    events: session?.events.map((entry) => ({ ...entry })) || [],
  }
}

export function withProgressDiagnostics(message, survey) {
  const context = getProgressDiagnostics(survey)
  const resumed = context.resumed
    ? '是（本次取得非空暫存）'
    : context.load === 'empty'
    ? '否（暫存為空）'
    : '未確認'
  const tail = `\n續填: ${resumed}; load=${context.load}\n版本: ${
    context.version
  }; build=${String(context.build).slice(0, 100)}\n進度事件: ${
    context.events
      .map(
        ({ event, at, count, detail }) =>
          `${event}@${at}${count === undefined ? '' : `(${count})`}${
            detail ? `[${detail}]` : ''
          }`
      )
      .join(', ') || '無'
  }`
  // tail 超過預算時只留 tail，避免負數 slice 從正文尾端回切、整則超過 Discord 2000 字
  const room = Math.max(0, 1950 - tail.length)
  if (room === 0) return tail.slice(0, 1950)
  const body = String(message)
  return (body.length > room ? `${body.slice(0, room - 1)}…` : body) + tail
}
